import React, {
  useState,
  Component,
  useEffect,
  useRef,
  useContext,
} from "react";
import {
  bearlog,
  BearDiv,
  BearPage,
  BearList,
  BearBackBorder,
  BearSelect,
  BearFloat,
  BearNavigation,
  BearBorder,
} from "@sillyscribe95/bear-ui-web";
import { instConst, instuArray } from "../consts/instConst";
import { MainContext } from "../context/MainContext";
import { EmojiPage } from "./EmojiPage";
import { PageMain } from "./PageMain";

import MIDISounds from "midi-sounds-react";
import { MidiComp } from "./MidiComp";
import { KeyShift } from "../components/KeyShift";
import { KeyComp } from "./KeyComp";
import { InstComps } from "../components/InstComps";
import { KeyChoose } from "../components/KeyChoose";
import { InstChoose } from "../components/InstChoose";
import { getKeyChord } from "../consts/chordConst";
import { KeyboardComp } from "./KeyboardComp";
import { KeyboardBase } from "./KeyboardBase";
import { ShareComp } from "../components/ShareComp";

export function HomeDesktop({ input }) {
  // 1const
  const [swapSet, setswapSet] = useState(
    //
    true
  );

  // 1right
  const okase = [
    //
    // "qweq",
    // InstChoose(),
    KeyChoose(),
    // ShareComp(),
  ];

  // 1topright
  const sdfwsa = BearList({
    horiz: true,
    list: okase,
    itemConfig: {
      style: {
        ...BearBorder("white", "5px"),
      },
    },
    bearName: "rightheade",
    typeList: "return",
  });

  // 1keyboard
  const kwsewqe =
    //
    KeyboardComp();
  // KeyboardBase()

  const emojiio = {
    // horiz: false,
    style: {
      textAlign: "center",
      fontSize: swapSet ? "20px" : "15vw",
    },
  };

  // 1emojiBase
  const fdsrwe = EmojiPage(emojiio);

  // 1bottomLeft
  const dfiwerwe = swapSet ? fdsrwe : kwsewqe;

  // 1center
  const kseasdew = swapSet ? kwsewqe : fdsrwe;

  const dfghrt = (
    <>
      {/* {ijfwe} */}
      {KeyComp()}
      {kseasdew}
    </>
  );

  const ajeqw = dfghrt;

  // 1footer
  const rigtos =
    //
    "asdfwer";
  // MidiComp(input)

  const dfgoker = BearFloat({
    style: BearBorder("red"),
    left: dfiwerwe,
    right: rigtos,
  });

  const nsdsdfa = {
    // style: BearBorder("lightgrey", "5px"),
    headerConfig: {
      // logo: ijfwe,
      // center: sdfwsa,
      right: sdfwsa,
    },
    // footerConfig:{
    //   className: "",
    // }
    footer: dfgoker,
  };

  return { config: nsdsdfa, item: ajeqw };
}
